import http, { HttpBodyUnpacking } from '@/lib/request.js'

import * as container from '@/lib/container.js'
import * as detective from '@/lib/detective.js'
import * as structure from '@/lib/structure.js'

import * as archive_model from '@/model/archive.js'

import type * as contract from './contract.js'




export type TRawDocumentType = Required<archive_model.THydratedDocumentType>

export type THydratedDocumentType = structure.Overwrite<
	Required<archive_model.THydratedDocumentType> & { is_online: boolean, is_signed: boolean },

	Pick<archive_model.TPopulatePaths, 'user' | 'contract'>

>


export function query (_id: string): HttpBodyUnpacking<string>
{
	return http.options(`/archive/${_id}`)

}


export function create
(
	_id: string,

	data: {
		name    : string
		sex     : string
		birthday: string

		identity: string

	},

)
:	HttpBodyUnpacking<string>
{
	return http.post(`/archive/${_id}`, data)

}


export function update
(
	_id: string,

	data: {
		name?    : string
		sex?     : '男' | '女'
		birthday?: Date

		identity?: string

		ethnicity?: string
		address?  : string

		issue?: string
		valid?: detective.Range<Date>

		idcard?  : string
		emblem?  : string
		portrait?: string

	},

)
:	HttpBodyUnpacking<void>
{
	return http.put(`/archive/${_id}`, data)

}


export function retrieve
(_id: string): HttpBodyUnpacking<THydratedDocumentType>
{
	return http.get(`/archive/${_id}`)

}

export function retrieve_contract
(_id: string): HttpBodyUnpacking<contract.TRawDocumentType>
{
	return http.get(`/archive/${_id}/contract`)

}

export function retrieve_contracts
(_id: string): HttpBodyUnpacking<contract.THydratedDocumentType[]>
{
	return http.get(`/archive/${_id}/contracts`)

}

export function retrieves
(params: container.PagerParams): HttpBodyUnpacking<THydratedDocumentType[]>
{
	return http.get('/archives', { params })

}


export function delete_
(_id: string): HttpBodyUnpacking<void>
{
	return http.delete(`/archive/${_id}`)

}
